import React, { useState, useEffect, useCallback } from 'react';

const ArrowLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18L9 12L15 6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 6L15 12L9 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const OVERLAY_Z = 9999;

const LightBox = ({ children, src, alt, Wrapper = 'div', gallery = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = () => {
    const idx = gallery.findIndex(item => item === src);
    setCurrentIndex(idx >= 0 ? idx : 0);
    setIsOpen(true);
  };

  const closeLightbox = (e) => {
    e.stopPropagation();
    setIsOpen(false);
  };

  const goNext = useCallback((e) => {
    if (e) e.stopPropagation();
    if (gallery.length > 0) {
      setCurrentIndex(prev => (prev + 1) % gallery.length);
    }
  }, [gallery.length]);

  const goPrev = useCallback((e) => {
    if (e) e.stopPropagation();
    if (gallery.length > 0) {
      setCurrentIndex(prev => (prev - 1 + gallery.length) % gallery.length);
    }
  }, [gallery.length]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, goNext, goPrev]);

  const currentSrc = gallery.length > 0 ? gallery[currentIndex] : src;

  const navBtnStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    cursor: 'pointer',
    zIndex: OVERLAY_Z + 1,
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  };

  return (
    <Wrapper onClick={openLightbox} style={{ cursor: 'pointer' }}>
      {children}
      {isOpen && (
        <div
          onClick={closeLightbox}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.85)',
            zIndex: OVERLAY_Z,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'default',
          }}
        >
          {/* Close button */}
          <button
            onClick={closeLightbox}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              zIndex: OVERLAY_Z + 1,
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CloseIcon />
          </button>

          {/* Prev button */}
          {gallery.length > 1 && (
            <button
              onClick={goPrev}
              style={{ ...navBtnStyle, left: '15px' }}
            >
              <ArrowLeft />
            </button>
          )}

          {/* Image */}
          <img
            src={currentSrc}
            alt={alt}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxHeight: '85vh',
              maxWidth: '85vw',
              objectFit: 'contain',
              borderRadius: '4px',
              boxShadow: '0 4px 30px rgba(0,0,0,0.5)',
            }}
          />

          {/* Next button */}
          {gallery.length > 1 && (
            <button
              onClick={goNext}
              style={{ ...navBtnStyle, right: '15px' }}
            >
              <ArrowRight />
            </button>
          )}

          {/* Counter */}
          {gallery.length > 1 && (
            <div style={{
              position: 'absolute',
              bottom: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              color: '#fff',
              fontSize: '14px',
              opacity: 0.7,
            }}>
              {currentIndex + 1} / {gallery.length}
            </div>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default LightBox;
